// extracted by mini-css-extract-plugin
export default {"root":"ProductLotEdit_root__tf-p2","row":"ProductLotEdit_row__evza4"};